import { modifier } from 'ember-modifier';

/**
 * A modifier that calls a function when the element is inserted into the DOM.
 * This is a replacement for the deprecated `did-insert` modifier.
 *
 * Usage:
 * {{on-insert this.myFunction}}
 * {{on-insert (fn this.myFunction arg1 arg2)}}
 */
export default modifier(function onInsert(element, [fn, ...args]) {
  if (typeof fn === 'function') {
    fn(element, ...args);
  }
});
